import { useListMembershipGroups } from 'src/features/memberships/api/useListMembershipGroups';
import { MembershipGroupsTable } from 'src/features/memberships/components/table/MembershipGroupsTable';
import useFilters from 'src/hooks/useFilters';
import usePagination from 'src/hooks/usePagination';
import useSearch from 'src/hooks/useSearch';
import useSorting from 'src/hooks/useSorting';
import { useParking } from 'src/providers/ParkingProvider';

const Memberships = () => {
    const { parkingId } = useParking();

    const { querySortingOptions, ...sorting } = useSorting({
        initialSortingState: [{ id: 'id', desc: true }],
    });
    const { querySearchOptions, ...search } = useSearch({ globalFilterKey: 'search' });
    const { queryFiltersOptions, ...filters } = useFilters();
    const { queryPaginationOptions, ...pagination } = usePagination();

    const {
        data: membershipGroups,
        isLoading: isLoadingMembershipGroups,
        isError: isErrorMembershipGroups,
        refetch: refetchMembershipGroups,
    } = useListMembershipGroups({
        ...querySearchOptions,
        ...queryPaginationOptions,
        ...querySortingOptions,
        ...queryFiltersOptions,
        parkingId: parkingId,
        reservation_type: 'NORMAL',
    });

    return (
        <MembershipGroupsTable
            membershipGroups={membershipGroups}
            isLoadingMembershipGroups={isLoadingMembershipGroups}
            isErrorMembershipGroups={isErrorMembershipGroups}
            refetchMembershipGroups={refetchMembershipGroups}
            sorting={sorting}
            search={search}
            pagination={pagination}
            filters={filters}
        />
    );
};

export default Memberships;
